import { Component } from '@angular/core';
import { OngletlayoutComponent } from '../../../components/layouts/ongletlayout/ongletlayout.component';
import { routeAlias } from '../../../../routesalias';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-setting',
  imports: [OngletlayoutComponent, RouterOutlet],
  templateUrl: './setting.component.html',
  styleUrl: './setting.component.css'
})
export class SettingLayout {
  // 1 seul onglet pour l'instant — extensible (cf. généralisation EAV backend)
  tableLinkForSetting = [
    {
      text: 'Info Système',
      link: routeAlias.setting.infoSysteme.home,
    },
    {
      text: 'Couleur',
      link: routeAlias.setting.themeColor.home,
    },
  ];
}